<template>
    <div class="pw fix headerTop">
        <div class="logo" @click="gotoHome">
            <span class="name">拍卖</span>
        </div>
        <div class="search">
            <el-input placeholder="请输入内容" v-model="selectInput" class="input-with-select" @keyup.enter.native="gotoSo">
                <el-select v-model="selectVal" slot="prepend" placement="bottom" placeholder="搜索" :popper-append-to-body="false">
                    <el-option
                        v-for="item in selectData"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <el-button slot="append" icon="el-icon-search" @click="gotoSo(selectVal,selectInput)">艺搜</el-button>
            </el-input>
        </div>
        <div class="artronAdvRight">
            <AdvSeal :advCode="'szeay1133'" :sendSc="true" :current_page="'PC端拍卖首页'" :banner_name="'右侧印章'" :banner_belong_area="'印章'"></AdvSeal>
        </div>

    </div>
</template>

<script>
import { sentSensors } from '@/utils/buriedPoint.js'
import AdvSeal from "@/components/advert/advSeal";

export default {
    name: "header",
    props:['showWater'],
    data(){
        return{
            selectData:[
                {
                    value:'auction',
                    label:'拍卖',
                },
                {
                    value:'gallery',
                    label:'画廊',
                },
                {
                    value:'news',
                    label:'资讯',
                },
                {
                    value:'artwork',
                    label:'艺术品',
                },
                {
                    value:'exhibit',
                    label:'展览',
                },
                {
                    value: 'artist',
                    label:'艺术家',
                },
                {
                    value: 'book',
                    label:'图书',
                },
            ],
            selectVal:'auction',
            selectInput:'',
            advYz:{}
        }
    },
    methods:{
        gotoHome(){
            this.$router.push({name:'home'})
        },
        gotoSo(plate,content){
            // 神策埋点
            let obj = this.selectData.find(e => e.value === plate)
            sentSensors(obj.label,content)
            let gotoUrl = '';
            switch (this.selectVal){
                case 'auction':
                    gotoUrl = 'https://artso.artron.net/auction/search_auction.php'
                    break
                case 'gallery':
                    gotoUrl = 'https://artso.artron.net/gallery/search_gallery.php'
                    break
                case 'news':
                    gotoUrl = 'https://artso.artron.net/news/search_newslist.php'
                    break
                case 'artwork':
                    gotoUrl = 'https://artso.artron.net/jewel/search_jewel.php'
                    break
                case 'exhibit':
                    gotoUrl = 'https://artso.artron.net/exhibit/search_exhibition.php'
                    break
                case 'artist':
                    gotoUrl = 'https://artso.artron.net/artist/search_artist.php'
                    break
                case 'book':
                    gotoUrl = 'https://artso.artron.net/ebook/search_book.php'
                    break
            }
            if(this.selectInput.trim()){
                if(!this.showWater){
                    window.open(gotoUrl + '?keyword='+encodeURIComponent(this.selectInput))
                }

            }else{
                this.$message('请输入搜索条件');
            }
        }
    },
    components:{
        AdvSeal
    }
}
</script>

<style scoped lang="scss">
.headerTop{position: relative;
    .logo{height:90px;display:flex;align-items: center;justify-content: space-between;background:url(../../assets/imgs/logo_new.png) no-repeat left center;background-size: 184px auto;padding-left: 204px;line-height: 46px;font-size: 26px;font-weight: bold;float:left;cursor: pointer;}
    .search{width:380px;height:38px;border:1px solid #D9D9D9;background-color: #fafafa;border-radius: 20px;display:flex;line-height: 38px;position: relative;float:left;margin-left: 144px;margin-top: 26px;}
    /deep/.el-input-group__prepend{padding:0;border:0;background-color: transparent;border-radius: 0;}
    /deep/.el-input__inner{border:0;height:36px;line-height: 36px;color:#27282d;padding:0;background-color: #fafafa;font-size: 16px;width:183px;font-family: "Microsoft YaHei";}
    /deep/.el-select{width:102px;text-align: center;cursor: pointer;border:0;border-radius: 0;margin:0;
        .el-input{border:0;border-radius: 0;background-color: transparent;
            .el-select__caret{line-height: 36px;}
        }
        .el-input__inner{height:33px;line-height: 33px;padding:0;font-size: 16px;color:#262626;padding-left: 20px;border:0;border-radius: 0;background-color: transparent;width:100%;}
    }
    /deep/.el-select-dropdown{margin:5px 0;}
    /deep/.popper__arrow{display:none;}
    /deep/.el-input-group__append{position: absolute;width:96px;height: 38px;right:-1px;top:-1px;line-height: 38px;color:#fff;background-color: #329D15;border-radius: 20px;padding:0;border:0;text-align: center;font-size: 18px;transition: .2s background-color ease-in-out;
        .el-icon-search{display:none;}
    }
    /deep/.el-input-group__append:hover{background-color: #0F820C;}
    .searchInput{width:210px;
        .input{width:100%;height:20px;padding:10px 0;background-color: transparent;font-size: 16px;color:#262626;border:0;}
    }
    .selBtn{width:96px;height:40px;border-radius: 20px;background-color: #329D15;text-align: center;font-size: 20px;color:#fff;position: absolute;right:-1px;top:-1px;transition: .2s background-color ease-in-out}
    .selBtn:hover{background-color: #0F820C}
    .advBigView{float:right;margin-top: 23px;}
}
/deep/.el-select-dropdown__item.selected{color:#329d15!important;}
/deep/.el-select-dropdown__item.hover{background-color: #f7f7f7!important;}
.artronAdvRight{float:right;margin-top: 20px;}
</style>